<template>
	<div id="app">
		<div class="header">
			<div style="float: left;margin-top: 10px;">
				<el-date-picker
				  v-model="now_time"
				  type="daterange"
				  value-format="yyyy-MM-dd"
				  range-separator="至"
				  style="vertical-align: middle;margin-top: -4px;"
				  start-placeholder="开始日期"
				  end-placeholder="结束日期">
				</el-date-picker>

				<input type="text" class="name" style="width: 90px;" v-model="vip_name" placeholder="会员姓名" @keyup.enter="search" />
				<input type="text" class="name" style="width: 90px;" v-model="cabeza_name" placeholder="家长姓名" @keyup.enter="search" />
				<input type="text" class="name" style="width: 140px;" maxlength="11" v-model="cabeza_tel" placeholder="家长电话" @keyup.enter="search" />

				<select name="" class="select3 name" v-model="usertype" style="width: 90px;height: 38px;padding-left:10px;">
					<option value="">分类</option>
					<option v-for="item in option2" :value="item.name">
						{{item.name}}
					</option>
				</select>
				<select name="" class="select1 name" v-model="selectVal" style="width: 90px;height: 38px;padding-left:10px;">
					<option value="">状态</option>
					<option v-for="item in option1" :value="item.name">
						{{item.name}}
					</option>
				</select>
                <!--<select name="" class="select1 name" v-model="vip" style="width: 90px;height: 38px;padding-left:10px;">-->
                    <!--<option value="">全部</option>-->
                    <!--<option v-for="item in vip_options" :value="item.value">-->
                        <!--{{item.name}}-->
                    <!--</option>-->
                <!--</select>-->
				<!--<select name="" class="select2 name" @change="market_save" v-if="show_zj == 1" v-model="select_Val" style="width: 90px;height: 38px;">-->
				<select name="" class="select2 name"  v-if="show_zj == 1" v-model="select_Val" style="width: 90px;height: 38px;">
					<option value="">顾问</option>
					<option v-for="(item,index) in options" :value="item.user_id">
						{{ item.username }}
					</option>
				</select>

				<el-button type="warning" @click="search" icon="el-icon-search"></el-button>
				<button class="refresh-btn" @click="clear_search">
					<i class="el-icon-refresh"></i>
				</button>
			</div>

			<el-button size="mini" @click="jump" style="background-color: #E6BE8A;border-color: #E6BE8A;padding: 7px 17px;margin-top: 17px;float: right;">新增潜客</el-button>
			<div style="float: right;width: 100px;" @click="getData(1,'df')">
				<img src="/static/qmsj/img/genjin/jinri.png" width="25" style="float: right;">
				<el-button size="mini" type="warning" style="padding: 7px 16px;background-color: #E6BE8A;border-color: #E6BE8A;">到访用户</el-button>
			</div>
			<div style="clear: both;"></div>
		</div>

		<el-table :data="tableData" border style="width: 100%" :cell-style="getClass"
		 @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="40">
			</el-table-column>
            <!--<el-table-column label="" width="50">-->
                <!--<template slot-scope="scope">-->
                    <!--<span>{{ scope.row.vip == 1 ? '会员' : '潜客' }}</span>-->
                <!--</template>-->
            <!--</el-table-column>-->
			<el-table-column prop="gj_type" label="状态" width="100">
			</el-table-column>
			<el-table-column label="创建时间" width="100">
				<template slot-scope="scope">
					<span>{{ scope.row.create_time ? scope.row.create_time : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="会员姓名" width="90">
				<template slot-scope="scope">
					<span style="cursor: pointer;" @click="pop(scope.row.user_id)">{{ scope.row.baobao_name ? scope.row.baobao_name : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="分类" width="80">
				<template slot-scope="scope">
					<span>{{ scope.row.usertype ? scope.row.usertype : '--' }}</span>
				</template>
			</el-table-column>


			<el-table-column label="电话" width="110">
				<template slot-scope="scope">
					<span>{{ scope.row.p_phone ? scope.row.p_phone : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="会员生日" width="100">
				<template slot-scope="scope">
					<span>{{ scope.row.baobao_birthday ? scope.row.baobao_birthday : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="上次跟进" width="100">
				<template slot-scope="scope">
					<span>{{ scope.row.last ? scope.row.last : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="跟进记录">
				<template slot-scope="scope">
					<span  style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">{{ scope.row.neirong ? scope.row.neirong : '--' }}</span>
				</template>
			</el-table-column>
		</el-table>

		<!--修改弹出框-->
		<form id="forms" action="" method="post">
			<el-dialog title="修改潜客信息" :visible.sync="dialogVisible" width="600px">
				<label style="margin: 0 5px 0 20px;">姓名</label>
				<input type="text" class="save-input" style="margin-right: 90px;" v-model="save_list2.baobao_name" placeholder="请输入会员姓名"
				 name="baobao_name" id="" value="" />
				<label>别名</label>
				<input type="text" class="save-input" placeholder="请输入会员别名" v-model="save_list2.baobao_name2" name="baobao_name2"
				 id="" value="" /><br />

				<label style="margin: 0 5px 0 20px;">生日</label>
				<el-date-picker value-format="yyyy-MM-dd" v-model="save_list2.baobao_birthday" name="baobao_birthday" size="mini"
				 type="date" placeholder="选择日期">
				</el-date-picker>

				<label style="margin-left: 90px;">性别</label>
				<el-radio name="baobao_sex" v-model="save_list2.baobao_sex" label="男">男</el-radio>
				<el-radio name="baobao_sex" v-model="save_list2.baobao_sex" label="女">女</el-radio><br />

                <label style="margin: 0 5px 0 20px;">来源</label>
                <select name="laiyuan" v-model="save_list2.laiyuan" style="width: 159px;height:28px;margin-top: 10px;" class="save-input">
                    <option v-for="item in option_laiyuan" :value="item.label">
                        {{item.label}}
                    </option>
                </select>
                <label style="margin-left: 90px;">备注</label>
                <input type="text" class="save-input" placeholder="请输入备注" v-model="save_list2.beizhu" name="beizhu"  value="" /><br />

				<div style="margin: 14px 5px 0 20px;">家长联系方式</div>
				<input type="hidden" name="user_id" id="" value="" v-model="save_list2.user_id" />
				<input type="hidden" name="token" id="" value="" v-model="token" />

				<div class="line" style="margin-top: 6px;" v-for="(item,index) in save_list">
					<span>关系</span>
					<select name="guanxi[]" v-model="item.g_value" style="width: 100px;height: 28px;margin-right: 10px;" class="save-input">
						<option v-for="item in relation" :value="item.value">
							{{item.name}}
						</option>
					</select>

					<span>姓名</span>
					<input type="text" placeholder="请输入家长姓名" style="width: 105px;margin-right: 10px;" v-model="item.p_name" class="save-input"
					 name="name[]" id="" value="" />

					<span>联系电话</span>
					<input type="tel" placeholder="请输入家长电话" maxlength="11" style="width: 105px;" v-model="item.p_phone" class="save-input"
					 name="phone[]" id="" value="" />
				</div>

				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="warning" @click="confirm_save">确 定</el-button>
				</span>
			</el-dialog>
		</form>

		<!--分页-->
		<div style="margin-top: 15px;">
			<el-button size="mini" type="warning" @click="move" style="float: left;margin-right: 15px;">转给他人</el-button>
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
			 background :page-size="10" prev-text="上一页" next-text="下一页" :total="totalNum">
			</el-pagination>
		</div>

		<!--转给他人-->
		<el-dialog title="提示" center top="25vh" :visible.sync="DialogVisible" width="25%">
			<span style="color: red;vertical-align: middle;">*</span>
			<label>选择销售：</label>
			<select name="" v-model="sell_name" style="width: 250px;height: 30px;">
				<option value="">请选择销售</option>
				<option v-for="(item,index) in sellData" :value="item.user_id">
					{{ item.username }}
				</option>
			</select>
			<span slot="footer" class="dialog-footer">
				<el-button @click="DialogVisible = false" size="mini">取 消</el-button>
				<el-button type="warning" @click="confirm_move" size="mini">确 定</el-button>
			</span>
		</el-dialog>

		<!--退回公海-->
		<el-dialog title="提示" center class="back_dialog" :visible.sync="send_state" width="30%">
			<span>确定删除此学员？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="send_state = false" size="mini">取 消</el-button>
				<el-button type="warning" @click="confirm_back" size="mini">确 定</el-button>
			</span>
		</el-dialog>

		<!--潜客详细信息-->
		<transition name="fade">
			<div v-show="popShow">
				<div @click="popShow = false" class="close-pop"></div>
				<div class="right-pop">
					<div></div>
					<div class="head">
						<img src="/static/qmsj/img/genjin/boshi.png" class="head-img" />
						<span class="name">{{popData.baobao_name ? popData.baobao_name : '--'}}</span>
						<div class="right">
							<span class="move" @click="void_user">无效用户</span>
							<span class="move" @click="send_back">删除</span>
							<img src="/static/qmsj/img/genjin/Close.png" @click="close" class="close" />
						</div>

						<div class="head_content">
							<span>最后跟进时间：{{popData.lasttime ? popData.lasttime : '--'}}</span>
							<span>下次跟进时间：{{popData.lastgjtime ? popData.lastgjtime : '--'}}</span>
							<span>负责销售：{{popData.gwname ? popData.gwname : '--'}}</span>
							<span>跟进状态：{{popData.gj_type ? popData.gj_type : '--'}}</span>
							<span>用户分类：
								<select class="select3 name" @change="get_type2" v-model="t_name" style="width: 90px;height: 25px;padding-left:10px;">
									<option value="">分类</option>
									<option v-for="item in option2" :value="item.name">
										{{item.name}}
									</option>
								</select>
								<!-- <input type="text" v-model="t_name" style="width: 80px;border-style: none; border-bottom-style: solid; outline: none;"
								 @focus="showtype=true" @blur="blurs">
								<button v-if="showtype&&showtype2" class="fencss" @click="get_type2(1)">保存</button>
								<button v-if="showtype&&!showtype2" class="fencss" @click="get_type2(2)">修改</button> -->
							</span>
						</div>
					</div>
					<!--tab切换-->
					<el-tabs v-model="activeName" type="border-card">
						<el-tab-pane name="first" label="详细信息">
							<el-button size="mini" style="float: right;" type="warning" @click="update(record_id)">修改信息</el-button>
							<!-- 展示信息的组件 -->
                            <genjinInfoBox :popData="popData"></genjinInfoBox>
						</el-tab-pane>

						<el-tab-pane name="second" label="跟进记录">
							<textarea v-model="text_val" placeholder="新建跟进记录...(必填，限200字)" name="" rows="" cols=""></textarea>
							<form class="down_form">
								<select name="" v-model="way_val" style="width: 12%;height: 27px;float: left;">
									<option value="">跟进方式</option>
									<option v-for="item in way" :value="item.name">
										{{item.name}}
									</option>
								</select>

								<el-date-picker value-format="yyyy-MM-dd" v-model="make_time" size="mini" type="date" placeholder="预约到访时间"></el-date-picker>

								<el-date-picker value-format="yyyy-MM-dd" v-model="last_time" size="mini" type="date" placeholder="下次跟进时间">
								</el-date-picker>

								<select name="" v-model="follow_val" @change="update_gj_type" style="height: 27px;margin-left: 5px;">
									<option value="">跟进状态</option>
									<option v-for="item in follow_type" :value="item.name">
										{{item.name}}
									</option>
								</select>
								<input type="button" class="issue" name="" id="" @click="issue" value="发布" />

								<!--跟进记录-->
								<div class="record-content" v-for="(item,index) in recordData" v-show="recordShow">
									<div class="record">
										<span>跟进时间: {{item.create_time ? item.create_time : '--'}}</span>
										<span>预约时间: {{item.st_time ? item.st_time : '--'}}</span>
										<span>
											跟进方式: {{item.fangshi ? item.fangshi : '--'}}
											<button :class="item.visittype=='已到访' ? 'yet' : 'not'" @click="visit(item.gj_id)" v-show="item.st_time">{{item.visittype}}</button>
										</span>
									</div>
									<img src="/static/qmsj/img/genjin/header.png" class="header-img" />
									<span class="img-txt">{{item.username ? item.username : '--'}}</span>
									<span class="right-txt" @click="del_record(item.gj_id)">删除</span>
									<div class="content">{{item.neirong ? item.neirong : '--'}}</div>
								</div>
							</form>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</transition>

		<!--删除跟进记录-->
		<el-dialog title="删除" :visible.sync="del_dialogVisible" width="25%">
			<span>是否删除此条记录？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="del_dialogVisible = false" size="mini">取 消</el-button>
				<el-button type="warning" @click="confirm_del" size="mini">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
    import genjinInfoBox from "../../components/genjinInfoBox";

    export default {
        components: {genjinInfoBox},
		data() {
			return {
				activeName: 'second',
				dialog_qiandao: true,
				now_time: '',
				value2: '',
				//分页
				totalNum: 0,
				now_page: 1,
				currentPage: 1,
				isShow: false,
				show_zj: 2,
				//表格
				vip_name: '',
                vip:'',
				cabeza_name: '',
				cabeza_tel: '',
				selectVal: '',
				select3Val: '',
				select_name: '',
				token: '',
				userid: '',
				popData: [],
				recordData: [], //跟进记录
				name_id: '', //会员姓名ID
				record_id: '',
				recordShow: false,
				sell_name: '',
				sellData: [],
				popShow: false,
				dialogVisible: false,
				DialogVisible: false,
				centerDialogVisible: false,
				market_num: 0, //顾问数量
				select_Val:'',
				//到访按钮
				visit_txt: '未到访',
				options: [],//顾问
				option1: [
					{
						name: '新客户'
					},
					{
						name: '新分配'
					},
					{
						name: '预约未到访'
					},
					{
						name: '已到访'
					},
					{
						name: '定金'
					}
				],
				follow_type: [
					{
						name: '预约未到访'
					},
					{
						name: '已到访'
					},
					{
						name: '定金'
					}
				],
				relation: [{
						name: '爸爸',
						value: 1
					},
					{
						name: '妈妈',
						value: 2
					},
					{
						name: '爷爷',
						value: 3
					},
					{
						name: '奶奶',
						value: 4
					},
					{
						name: '姥爷',
						value: 5
					},
					{
						name: '姥姥',
						value: 6
					},
				],
				option2: [
					{name:'来了就签'},
					{name:'持续跟进'},
					{name:'重点跟进'},
					{name:'不考虑'},
					{name:'养单'},
				],
                vip_options: [
                    {
                        name: '会员',
                        value: 1
                    },
                    {
                        name: '潜客',
                        value: 2
                    }
                ],
				way: [{
						name: '电话'
					},
					{
						name: '微信'
					},
					{
						name: '短信'
					},
					{
						name: '到店'
					},
					{
						name: '其它'
					},
				],
				week: [{
						name: '星期一',
						value: 1
					},
					{
						name: '星期二',
						value: 2
					},
					{
						name: '星期三',
						value: 3
					},
					{
						name: '星期四',
						value: 4
					},
					{
						name: '星期五',
						value: 5
					},
					{
						name: '星期六',
						value: 6
					},
					{
						name: '星期日',
						value: 7
					}
				],
				courseData: [], //班级名称
				text_val: '', //跟进内容
				way_val: '', //跟进方式
				week_val: '', //跟进日期
				make_time: '', //预约时间
				last_time: '', //下次跟进时间
				follow_val: '', //跟进状态
				course_val: '', //选择班级名称
				ids: '', //记录id
				tableData: [],
				tables: [],
				//修改弹出框
				radio: '男',
				save_list: [],
				save_list2: [],
				del_dialogVisible: false, //删除记录
				del_id: '', //删除记录ID
				send_state: false, //退回公海
				pageSize: 10,
				multipleSelection: [], //多选框
				showtype: false, //是否显示用户分类
				showtype2: false, //是否显示用户分类
				t_name: '', //用户分类
				time_s:'',
				time_e:'',
				classify:'',
				d_id:'',
                option_laiyuan:'',
				usertype:'',
				isSubmit: false
			}
		},
		created() {
			//下拉框数据
			let that = this
			that.token = that.$cookies.get('token');

			//下拉框数据
			$.ajax({
				url: process.env.apiUrl +'saas/nn/sales',
				type: 'post',
				data: {
					token: that.token
				},
				success: function(data, status) {
					that.options = data.data
				},
				fail: function(err, status) {
					console.log(err)
				}
			})

			//请求表格数据
			that.getData()
			that.get_laiyuan()
		},
		methods: {
            //切换跟进状态
            update_gj_type(){
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/nn/update_gj_type',
                    type: 'post',
                    data: {
                        token: that.token,
                        user_id:that.record_id,
                        gj_type:that.follow_val
                    },
                    success: function(e) {

                    },
                })
            },
			//新增潜客
			jump(){
				this.$router.push('/insert')
			},
		    get_laiyuan(){
		        let that = this;
                // 来源下拉
                $.ajax({
                    url: process.env.apiUrl +'saas/index/get_source',
                    type: 'post',
                    data: {
                        token: that.token
                    },
                    success: function(e) {
                        that.option_laiyuan = e.data
                    },
                })
            },
			//无效用户
			void_user(done) {
				this.$confirm('确认标记为无效用户？')
					.then(_ => {
						let that = this
						that.get_void()
						that.popShow = false
					})
					.catch(_ => {});
			},
			get_void() {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/nn/tagged_invalid_user',
					type: 'post',
					data: {
						token: that.token,
						user_id: that.record_id
					},
					success: function(data, status) {
						if (data.status == 1) {
							that.$message({
								message: '标记无效用户成功',
								type: 'success'
							})
							that.getData(that.d_id)
						} else {
							that.$message.error({
								message: data.msg
							})
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//表格数据
			getData(i=0,df='') {
                let that = this
			    if(df == 'df'){
                    that.now_page = 1;
                    that.currentPage = 1;
                }
                that.d_id = i

				const loading = that.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});


				$.ajax({
					url: process.env.apiUrl +'saas/qk/gd',
					type: 'post',
					data: {
                        time_s: that.time_s,
                        time_e: that.time_e,
						name: that.vip_name,
						pname: that.cabeza_name,
						pphone: that.cabeza_tel,
						type: that.selectVal,
						page: that.now_page,
						usertype: that.usertype,
						df: i,
                        salesperson: that.select_Val,
						token: that.token
					},
					success: function(data, status) {
						loading.close();
						if (data.status == 1) {
							that.tableData = data.data
							that.totalNum = Number(data.map.count)
							that.show_zj = data.show_zj;
						} else {
							that.tableData = [];
							that.totalNum = Number(0)
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//搜索
			search() {
				let that = this
                that.now_page = 1;
				that.currentPage = 1;
				that.d_id = 0;
				$.ajax({
					url: process.env.apiUrl +'saas/qk/gd',
					type: 'post',
					data: {
						time_s: that.time_s,
						time_e: that.time_e,
						name: that.vip_name,
						pname: that.cabeza_name,
						pphone: that.cabeza_tel,
						type: that.selectVal,
						usertype: that.usertype,
						page: that.now_page,
                        salesperson: that.select_Val,
						token: that.token
					},
					success: function(data, status) {
						if (data.status == 1) {
							that.tableData = data.data
							that.totalNum = Number(data.map.count)
						} else {
							that.tableData = []
							that.totalNum = Number(0)
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//姓名高亮
			getClass({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 3) {
					return 'color:rgb(98, 158, 241)'
				}
			},
			//修改信息
			update(id) {
				let that = this
				that.dialogVisible = true
				$.ajax({
					url: process.env.apiUrl +'saas/Qk/edit_qk_info',
					type: 'post',
					data: {
						user_id: id,
						token: that.token
					},
					success: function(data, status) {
						that.save_list = data.guanxi
						that.save_list2 = data.userinfo
						console.log(that.save_list)
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//确认修改
			confirm_save() {
				this.dialogVisible = false
				//提交修改表单
				var formData = new FormData($('#forms')[0]);
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/Qk/update_qk_info',
					type: "post",
					async: false,
					processData: false, // 不处理发送的数据，因为data值是Formdata对象，不需要对数据做处理
					contentType: false, // 不设置Content-type请求头
					data: formData,
					success: function(data) {
						if (data.status == 1) {
							that.getData(that.d_id);
							that.save_success();
							that.pop(that.record_id);
						}
					},
					fail: function(err) {
						console.log(err)
					}
				})
			},
			//修改成功
			save_success() {
				this.$message({
					message: '修改成功',
					type: 'success'
				});
			},
			//			右侧弹出框
			pop(id) {
				document.documentElement.scrollTop = document.body.scrollTop = 0;
				this.popShow = true
				this.record_id = id

				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/nn/details',
					type: 'post',
					data: {
						userid: id,
						token: that.token
					},
					success: function(data, status) {
						that.popData = data.data
                        that.follow_val = data.data.gj_type;
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
				//跟进记录数据
				that.get_record();
				// 用户分类
				that.get_type()
			},
			blurs() {
				let that = this
				setTimeout(function() {
					that.showtype = false
				}, 500)
			},
			// 用户分类
			get_type() {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/nn/usertype',
					type: 'post',
					data: {
						userid: that.record_id,
						token: that.token
					},
					success: function(data, status) {
						if (data.data) {
							that.showtype2 = false
							that.t_name = data.data
						} else {
							that.showtype2 = true
							that.t_name = ''
						}
					},
				})
			},
			get_type2(i) {
				let that = this
				// if(i==1){
				// 	var mag='保存成功'
				// }else{
				// 	var mag="修改成功"
				// }
				$.ajax({
					url: process.env.apiUrl +'saas/nn/usertype',
					type: 'post',
					data: {
						userid: that.record_id,
						token: that.token,
						usertype: that.t_name,
					},
					success: function(data, status) {
						if (data.status == 1) {
							that.$message({
								message:data.msg,
								type: 'success'
							});
							that.get_type()
                            that.getData();
						} else {

						}
					},
				})
			},
			//跟进记录
			get_record() {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/nn/follow',
					type: 'post',
					data: {
						user_id: that.record_id,
						token: that.token
					},
					success: function(data, status) {
						that.recordData = data.data
						if (data.status == 1) {
							that.recordShow = true
							that.recordLength = data.data.length
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//删除跟进记录
			del_record(id) {
				let that = this
				that.del_dialogVisible = true

				$.ajax({
					url: process.env.apiUrl +'saas/nn/del',
					type: 'post',
					data: {
						gj_id: id,
						token: that.token
					},
					success: function(data, status) {
						console.log(data)
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//确认删除记录
			confirm_del() {
				this.del_dialogVisible = false

				let that = this
				that.get_record();
			},
			//多选
			handleSelectionChange(val) {
				let arr = []
				for (let i in val) {
					arr.push(val[i].user_id)
				}
				this.multipleSelection = arr
			},
			//转给他人
			move() {
				if (this.multipleSelection.length == 0) {
					this.$message.error({
						message: '请先选择客户'
					})
				} else {
					let that = this
					that.DialogVisible = true
					//销售人员列表
					$.ajax({
						url: process.env.apiUrl +'saas/qk/yxlb',
						type: 'post',
						data: {
							token: that.token
						},
						success: function(data, status) {
							if (data.status == 1) {
								that.sellData = data.data
							} else {
								that.$message.error({
									message: data.msg
								})
							}
						},
						fail: function(err, status) {
							console.log(err)
						}
					})
				}
			},
			//确认
			confirm_move() {
				if (!this.sell_name) {
					this.$message.error({
						message: '请先选择销售'
					})
				} else {
					let that = this
					$.ajax({
						url: process.env.apiUrl +'saas/qk/zgtr',
						type: 'post',
						data: {
							user_id: that.multipleSelection,
							uid: that.sell_name,
							token: that.token
						},
						success: function(data, status) {
							if (data.status == 1) {
								that.DialogVisible = false
								that.$message({
									message: '分配成功',
									type: 'success'
								});
								setTimeout(() => {
									that.getData(that.d_id)
								}, 1000)
							} else {
								that.$message.error({
									message: data.msg
								})
							}
						},
						fail: function(err, status) {
							console.log(err)
						}
					})
				}
			},
			//发布
			issue() {
				let that = this
				if (that.text_val == '') {
					that.$message.error("请输入跟进内容");
					return false;
				}
				if (that.way_val == '') {
					that.$message.error("请输入跟进方式");
					return false;
				}
				if (this.isSubmit) {
					return
				}
				this.isSubmit = true
				$.ajax({
					url: process.env.apiUrl +'saas/nn/addfollow',
					type: 'post',
					data: {
						bao_id: that.record_id,
						neirong: that.text_val,
						fangshi: that.way_val,
						st_time: that.make_time,
						lasttime: that.last_time,
						zhuangtai: that.follow_val,
						token: that.token
					},
					success: function(data, status) {
						if (data.status == 1) {
							that.getData()
							that.$message.success(data.msg);
							//添加跟进记录
							that.get_record();
							that.getData(that.d_id);
							//清空已添加的跟进内容
							that.text_val = ''; //文本域
							that.way_val = ''; //跟进方式
							that.week_val = ''; //跟进日期
							that.make_time = ''; //预约时间
							that.last_time = ''; //下次跟进时间
							that.follow_val = ''; //跟进状态
						} else {
							that.$message.error(data.msg);
						}
					},
					fail: function(err, status) {
						console.log(err)
					},
					complete: function() {
						that.isSubmit = false
					}
				})
			},
			//到访按钮
			visit(id1, key) {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/qk/dfqh',
					type: 'post',
					data: {
						id: id1,
						token: this.token
					},
					success: function(data, status) {
						that.get_record();
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//关闭右侧弹出框
			close() {
				this.popShow = false
			},
			//退回公海
			send_back() {
				this.send_state = true
			},
			confirm_back() {
				this.send_state = false

				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/qk/tuihui',
					type: 'post',
					data: {
						user_id: that.record_id,
						token: that.token
					},
					success: function(data, status) {
						if (data.status == 1) {
							that.popShow = false;
							//刷新视图
							that.getData(that.d_id);
							that.send_success();
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			send_success() {
				this.$message({
					message: '已退回公海',
					type: 'success'
				});
			},
			//分页
			handleCurrentChange(val) {
				this.now_page = val
				this.getData(this.d_id)
			},
			//清空搜索条件
			clear_search() {
				this.vip_name = '';
				this.cabeza_name = '';
				this.cabeza_tel = '';
				this.selectVal = '';
				this.select_Val = '';
				this.select3Val = '';
				this.time_s = '';
				this.time_e = '';
				this.now_time = '';
				this.vip = '';
				this.usertype = '';
                this.getData();
			},
			//根据星期选择课程
			week_save() {
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/qk/xzkc',
					type: 'post',
					data: {
						week: that.week_val,
						token: that.token
					},
					success: function(data, status) {
						that.courseData = data.data
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
		},
		watch:{
			now_time(){
				if(this.now_time){
					this.time_s = this.now_time[0]
					this.time_e = this.now_time[1]
				}else{
					this.time_s = ''
					this.time_e = ''
				}
			}
		}
	};
</script>

<style>
	.el-dialog__header {
		padding: 8px 20px;
		color: #FFFFFF;
		background: #E6BE8A;
		text-align: center;
	}

	.el-dialog__title {
		color: #FFFFFF;
	}

	.el-input__inner {
		height: 36px;
		line-height: 36px;
	}

	.el-dialog__headerbtn {
		top: 13px;
	}

	.el-date-editor .el-range-separator{
		width: auto;
	}

	.el-button--primary{
		background-color: #E6BE8A;
		border-color: #E6BE8A;
	}
</style>

<style lang="less" scoped="scoped">
	.close-pop{
		width: calc(100% - 800px);
		height: 90vh;
		position: absolute;
		top: 0;
		left: 0;
	}
	.text_hidden{
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	/*修改弹出框*/
	.el-dialog {
		.save-input {
			width: 160px;
			height: 28px;
			line-height: 28px;
			border-radius: 2px;
			border: 1px solid gainsboro;
			padding-left: 5px;
		}

		.el-date-editor.el-input,
		.el-date-editor.el-input__inner {
			width: 160px;
			margin-top: 10px;
		}

		.line {
			margin-top: 10px;

			.add {
				width: 20px;
				vertical-align: middle;
				text-align: center;
				font-weight: bolder;
				display: inline-block;
				background: #79C4C7;
				border-radius: 50%;
				color: white;
				font-size: 15px;
				cursor: pointer;
			}
		}
	}

	.fencss {
		padding:0 8px;
		color: #fff;
		background-color: #E6BE8A;
		border:0;
		border-radius: 2px;
	}

	/*确认删除*/
	.header .el-button--default {
		color: white;
	}


	#app {
		padding: 10px;
		position: relative;
	}

	.right-pop {
		width: 800px;
		display: inline-block;
		position: absolute;
		background: white;
		border: 1px solid gainsboro;
		top: 0;
		right: 0;
		z-index: 99;
		overflow: hidden;
		overflow-y: scroll;

		.head {
			padding: 10px;

			.head-img {
				width: 35px;
				float: left;
			}

			.name {
				margin-top: 9px;
				margin-left: 8px;
				display: inline-block;
			}

			.right {
				float: right;
				margin-top: 5px;

				.move {
					display: inline-block;
					float: left;
					width: 85px;
					text-align: center;
					padding: 5px 0;
					border: 1px solid #adadad;
					border-radius: 2px;
					margin-right: 2px;
					cursor: pointer;
				}

				.el-button--text {
					float: left;
					width: 85px;
					text-align: center;
					padding: 7px 0;
					border: 1px solid #adadad;
					border-radius: 2px;
					color: black;
				}

				.close {
					margin-top: 5px;
					margin-left: 7px;
					margin-right: 5px;
					width: 20px;
				}
			}

			.head_content {
				margin-bottom: 7px;
				clear: both;

				span {
					display: inline-block;
					margin-left: 30px;
					padding-top: 12px;
				}
			}
		}

		.el-tabs--border-card {
			box-shadow: none;
		}

		textarea {
			width: 100%;
			height: 63px;
		}

		.fade-enter-active,
		.fade-leave-active {
			transition: opacity 1s;
		}

		.fade-enter,
		.fade-leave-to {
			opacity: 0;
		}

		.el-tabs--border-card {
			border-left: 0;
			border-bottom: 0;
		}

		.down_form {
			margin-top: 15px;
			padding-bottom: 20px;
			max-height: 500px;
			overflow: hidden;
			overflow-y: scroll;

			.el-date-editor.el-input,
			.el-date-editor.el-input__inner {
				width: 135px;
				margin-left: 5px;
				float: left;
			}

			.issue {
				padding: 3px 11px;
				color: #fff;
				background-color: #E6BE8A;
				border: 1px solid #E6BE8A;
				border-radius: 2px;
			}


			.record-content {
				margin-bottom: 10px;

				.record {
					height: 40px;
					line-height: 40px;
					margin-bottom: 10px;
					margin-top: 20px;
					padding-left: 20px;
					background-color: rgb(241, 241, 241);
					color: rgb(102, 102, 102);

					span {
						display: inline-block;
						padding-right: 50px;
					}

					.yet {
						width: 55px;
						line-height: 30px;
						background-color: #449d44;
						border: 0;
						border-radius: 5px;
						color: white;
						margin-left: 10px;
						font-size: 14px;
						cursor: pointer;
						outline: none;
					}

					.not {
						width: 55px;
						line-height: 30px;
						background-color: #f0ad4e;
						border: 0;
						border-radius: 5px;
						color: white;
						margin-left: 10px;
						font-size: 14px;
						cursor: pointer;
						outline: none;
					}
				}

				.header-img {
					float: left;
					margin: 0 15px;
					width: 50px;
				}

				.img-txt {
					display: inline-block;
					padding: 2px 5px;
					border-radius: 10px;
					color: #fff;
					background-color: #E6BE8A;
					border-color: #2e6da4;
					font-size: 14px;
					font-weight: bold;
					margin-top: 18px;
				}

				.right-txt {
					float: right;
					padding-top: 18px;
					padding-right: 30px;
					color: rgb(93, 156, 236);
					display: inline-block;
					cursor: pointer;
				}

				.content {
					padding-left: 84px;
					min-height: 50px;
					clear: both;
				}
			}

		}

	}

	.header {
		margin-bottom: 15px;

		.name {
			display: inline-block;
			height: 36px;
			padding-left: 16px;
			margin-left: 5px;
			font-size: 14px;
			line-height: 1.42857143;
			color: #555;
			background-color: #fff;
			border: 1px solid #ccc;
			border-radius: 4px;
		}

		.el-button {
			padding: 6px 14px;
			margin-left: 15px;
			margin-right: 6px;
			vertical-align: middle;
		}

		.refresh-btn {
			width: 43px;
			border: 1px solid #E4E7ED;
			line-height: 24px;
			background-color: white;
			border-radius: 2px;
			cursor: pointer;
			vertical-align: middle;
		}

		.delete {
			color: #fff;
			border: 0;
			background-color: #E6BE8A;
			display: inline-block;
			margin-bottom: 0;
			font-size: 14px;
			font-weight: 400;
			line-height: 1.42857143;
			text-align: center;
			border-radius: 3px;
			cursor: pointer;
			margin-left: 5px;
		}
	}

	.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
		width: 250px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/genjin/gendan.vue